import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animationLabel() {
  /* ====================================
  # ラベルアニメーション
  ==================================== */
  const initLabelAnimation = () => {
    const labelElements = document.querySelectorAll('.c-label');
    
    labelElements.forEach((label) => {
      ScrollTrigger.create({
        trigger: label,
        start: 'top 60%',
        once: true,
        onEnter: () => {
          label.classList.add('c-label--animated');
        }
      });
    });
  };

  // ラベルアニメーションを初期化
  initLabelAnimation();
}